<ol #autocompleteOptions id="{{ listBoxId }}" [class]="rclass" role="listbox" [attr.aria-labelledby]="labelledBy">
    <ridango-simple-list-item
        *ngFor="let item of items; let i = index"
        [id]="listItemIdPrefix + i"
        [item]="item"
        [isSelected]="selectedIndex === i"
        [rclass]="'autocomplete__choice'"
        (onItemSelected)="itemSelected($event)"
    ></ridango-simple-list-item>
</ol>
